import { render, staticRenderFns } from "./PantallaLogin.vue?vue&type=template&id=bcc9ff66&"
import script from "./PantallaLogin.vue?vue&type=script&lang=js&"
export * from "./PantallaLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports